import '@mdxeditor/editor/style.css';

import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  DiffSourceToggleWrapper,
  diffSourcePlugin,
  headingsPlugin,
  InsertTable,
  ListsToggle,
  listsPlugin,
  quotePlugin,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo
} from '@mdxeditor/editor';

export const TextEditorToolBar = () => {
  return (
    <DiffSourceToggleWrapper>
      <UndoRedo />
      <BlockTypeSelect />
      <BoldItalicUnderlineToggles />
      <CodeToggle />
      <InsertTable />
      <ListsToggle />
    </DiffSourceToggleWrapper>
  );
};

TextEditorToolBar.displayName = 'TextEditorToolBar';

export const MDX_EDITOR_CONFIG = [
  diffSourcePlugin(),
  headingsPlugin(),
  listsPlugin(),
  quotePlugin(),
  tablePlugin(),
  thematicBreakPlugin(),
  toolbarPlugin({
    toolbarContents: () => <TextEditorToolBar />
  })
];
